import { Head } from '@inertiajs/react';

interface MetaHeadProps {
    title: string;
    description?: string;
    keywords?: string;
    image?: string;
    imageAlt?: string;
    url?: string;
    type?: 'website' | 'article' | 'profile';
    author?: string;
    robots?: string;
    twitterCard?: 'summary' | 'summary_large_image' | 'app' | 'player';
    twitterSite?: string;
    twitterCreator?: string;
    ogLocale?: string;
    additionalMeta?: Record<string, string>;
    structuredData?: object;
    canonical?: string;
    noIndex?: boolean;
    children?: React.ReactNode;
}

export default function MetaHead({
    title,
    additionalMeta,
    structuredData,
    noIndex = false,
    children,
}: MetaHeadProps) {
    // Title only — OG/Twitter/canonical/description are now emitted server-side
    // by app.blade.php (with controller-set View::share('metadata', [...]) overrides).
    // Letting React inject a second copy at hydration caused duplicate tags in the
    // DOM and overwrote correct server values with VITE_APP_URL fallbacks like
    // 'http://localhost/logo.svg'. The Head component still sets <title> so browser
    // tabs update on client-side navigation.
    return (
        <Head title={title}>
            {noIndex && <meta name="robots" content="noindex, nofollow" />}

            {additionalMeta && Object.entries(additionalMeta).map(([key, value]) => <meta key={key} name={key} content={value} />)}

            {structuredData && <script type="application/ld+json">{JSON.stringify(structuredData)}</script>}

            {children}
        </Head>
    );
}
